import {
    FETCH_DATA_FROM_CRITEO,
    MERGE_SPONSORED_AND_ORGANIC_PRODUCTS,
    TRIGGER_CRITEO_BEACON,
} from '../actionTypes/CriteoActionTypes';

export const getProductListFromCriteo = (payload) => ({
    type: FETCH_DATA_FROM_CRITEO,
    payload,
});

export const mergeSponsoredAndORganicProducts = (payload) => ({
    type: MERGE_SPONSORED_AND_ORGANIC_PRODUCTS,
    payload,
});

export const triggerCriteoBeacon = (payload) => ({
    type: TRIGGER_CRITEO_BEACON,
    payload,
});
